export enum SettingsValueType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  COLOR = 'COLOR',
  BOOLEAN = 'BOOLEAN',
  SELECT = 'SELECT',
  MULTISELECT = 'MULTISELECT',
}
